import { render } from "./SpecialisedPage.vue?vue&type=template&id=90eb32de&scoped=true"
import script from "./SpecialisedPage.vue?vue&type=script&lang=js"
export * from "./SpecialisedPage.vue?vue&type=script&lang=js"

import "./SpecialisedPage.vue?vue&type=style&index=0&id=90eb32de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90eb32de"]])

export default __exports__